export const chart1Config = {
	series: [
		{
			name: "Vector Count",
			data: [10, 21, 35, 41, 59, 62, 79],
		},
	],
	options: {
		chart: {
			type: "line",
			toolbar: {
				show: false,
			},
			zoom: {
				enabled: false,
			},
			foreColor: "#969696",
		},
		tooltip: {
			theme: "dark",
		},
		dataLabels: {
			enabled: false,
		},
		xaxis: {
			categories: ["M", "T", "W", "T", "F", "S", "S"],
			labels: {
				style: {
					colors: "#969696",
					fontSize: "14px",
				},
			},
		},
		yaxis: {
			labels: {
				style: {
					colors: "#969696",
					fontSize: "14px",
				},
			},
		},
		legend: {
			showForSingleSeries: true,
		},
		stroke: {
			curve: "smooth",
		},
		grid: {
			xaxis: {
				lines: {
					show: false,
				},
			},
			yaxis: {
				lines: {
					show: false,
				},
			},
		},

		colors: ["#0B1544"],
	},
};

export const chart2Config = {
	series: [
		{
			name: "Line 1",
			data: [10, 20, 30, 40, 50, 60, 70],
		},
		{
			name: "Line 2",
			data: [15, 25, 35, 45, 55, 65, 75],
		},
		{
			name: "Series 3",
			data: [45, 32, 56, 21, 38, 64, 73],
		},
	],
	options: {
		chart: {
			type: "line",
			toolbar: {
				show: false,
			},
			zoom: {
				enabled: false,
			},
			foreColor: "#969696",
		},
		tooltip: {
			theme: "dark",
		},
		dataLabels: {
			enabled: false,
		},
		xaxis: {
			categories: ["M", "T", "W", "T", "F", "S", "S"],
			labels: {
				style: {
					colors: "#969696",
					fontSize: "14px",
				},
			},
		},
		yaxis: {
			labels: {
				style: {
					colors: "#969696",
					fontSize: "14px",
				},
			},
		},
		legend: {
			show: true,
		},
		stroke: {
			curve: "smooth",
		},
		grid: {
			xaxis: {
				lines: {
					show: false,
				},
			},
			yaxis: {
				lines: {
					show: false,
				},
			},
		},

		colors: ["#71C9EC", "#B9962F", "#16BF5D"],
	},
};
